/**
 * 特集商品付替画面の特集一覧取得クラス
 *
 * @export Feature
 * @class Feature
 */
export class Feature {
  constructor(
    public FeatureCode: string,
    public FeatureName: string,
  ){}
}
	